// extracted by mini-css-extract-plugin
export default {"HotelTestimonials":"Testimonial_HotelTestimonials__U+v8s","HotelsTestimonialText":"Testimonial_HotelsTestimonialText__5kfrW"};